var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1V6",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22228 3.92605C5.24085 4.21868 4.33757 4.75184 3.60028 5.48913C2.43339 6.65602 1.77783 8.23867 1.77783 9.88891L14.2223 9.88891C14.2223 8.23867 13.5667 6.65602 12.3998 5.48913C11.6625 4.75184 10.7593 4.21868 9.77783 3.92605V6.51852C9.77783 7.33672 8.98189 8 8.00005 8C7.01821 8 6.22228 7.33672 6.22228 6.51852V3.92605Z",
    fill: "white",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10.7778,
    width: 2.66667,
    height: 16,
    rx: 1.33333,
    transform: "rotate(90 16 10.7778)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractor);
export default __webpack_public_path__ + "static/media/contractor.645a968c.svg";
export { ForwardRef as ReactComponent };